import React, { useEffect, useRef, useState } from 'react';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';

function GalleryStrip({ title, images, isMobile }) {
  const [photoIndex, setPhotoIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [showLeft, setShowLeft] = useState(false);
  const [showRight, setShowRight] = useState(false);
  const containerRef = useRef(null);

  const checkScroll = () => {
    const el = containerRef.current;
    if (!el) return;
    setShowLeft(el.scrollLeft > 0);
    setShowRight(el.scrollLeft + el.clientWidth < el.scrollWidth);
  };

  const scroll = (direction) => {
    const el = containerRef.current;
    if (!el) return;
    el.scrollBy({
      left: direction === "left" ? -200 : 200,
      behavior: "smooth",
    });
  };

  useEffect(() => {
  const id = requestAnimationFrame(() => {
    setTimeout(checkScroll, 50);
  });

  return () => cancelAnimationFrame(id);
}, []);

  const arrowLeftStyle = {
  position: "absolute",
  left: 0,
  top: "50%",
  transform: "translateY(-50%)",
  zIndex: 2,
  background: "rgba(0,0,0,0.5)",
  color: "#fff",
  border: "none",
  cursor: "pointer",
  fontSize: "24px",
  padding: "10px",
};

const arrowRightStyle = {
  ...arrowLeftStyle,
  left: "auto",
  right: 0,
};

  return (
    <div style={{ marginTop: 40 }}>
      <h2>{title}</h2>

      <div style={{ position: "relative" }}>
        {showLeft && (
          <button
            onClick={() => scroll("left")}
            style={arrowLeftStyle}
          >
            ◀
          </button>
        )}

        <div
          ref={containerRef}
          onScroll={checkScroll}
          style={{
            display: "flex",
            gap: "10px",
            overflow: "hidden",
            padding: "10px",
          }}
        >
          {images.map((src, idx) => (
            <img
              key={idx}
              src={src}
              alt=""
              onClick={() => {
                setPhotoIndex(idx);
                setIsOpen(true);
              }}
              style={{
                height: isMobile ? "200px" : "300px",
                cursor: "pointer",
                borderRadius: "8px",
                flexShrink: 0,
              }}
            />
          ))}
        </div>

        {showRight && (
          <button
            onClick={() => scroll("right")}
            style={arrowRightStyle}
          >
            ▶
          </button>
        )}

        {isOpen && (
          <Lightbox
            open={isOpen}
            close={() => setIsOpen(false)}
            index={photoIndex}
            slides={images.map((src) => ({ src }))}
            on={{ view: ({ index }) => setPhotoIndex(index) }}
          />
        )}
      </div>
    </div>
  );
}

export default function Gallery() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [showLeft, setShowLeft] = useState(false);
  const [showRight, setShowRight] = useState(false);
  const containerRef = useRef(null);
  const [activeImages, setActiveImages] = useState([]);

  const orkImages = [
  '/images/warhammer/orkGhazghkull.jpg',
  '/images/warhammer/orkWazbomBlastajet.jpg',
  '/images/warhammer/orkBigMekInMegaArmor.jpg',
  '/images/warhammer/orkDaRedGobbo.jpg',
  '/images/warhammer/orkMegatrakkScrapjet.jpg',
  '/images/warhammer/orkMobMobile.jpg',
  '/images/warhammer/orkTrukk.jpg',
];

const necronImages = [
  '/images/warhammer/necronSzeras.jpg',
  '/images/warhammer/necronOrikan.jpg',
  '/images/warhammer/necronCanoptekhDoomstalker.jpg',
  '/images/warhammer/necronChronomancer.jpg',
  '/images/warhammer/necronOverlordWithTranslocationShroud.jpg',
  '/images/warhammer/necronSilentKing.jpg',
  '/images/warhammer/necronVoidDragon.jpg',
];

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const checkScroll = () => {
    const el = containerRef.current;
    if (!el) return;
    setShowLeft(el.scrollLeft > 0);
    setShowRight(el.scrollLeft + el.clientWidth < el.scrollWidth);
  };

  const scroll = (direction) => {
    const el = containerRef.current;
    const scrollAmount = 200;
    if (!el) return;

    el.scrollBy({ left: direction === 'left' ? -scrollAmount : scrollAmount, behavior: 'smooth' });
  };

  const renderStrip = (images) => (
  <div style={{ position: 'relative', marginTop: '20px' }}>
    {showLeft && (
      <button onClick={() => scroll('left')} style={arrowLeftStyle}>◀</button>
    )}

    <div
      ref={containerRef}
      onScroll={checkScroll}
      style={{
        display: 'flex',
        gap: '10px',
        overflowX: "auto",
        overflowY: "hidden",
        scrollBehavior: 'smooth',
        padding: '10px',
      }}
    >
      {images.map((src, idx) => (
        <img
          key={idx}
          src={src}
          alt=""
          onClick={() => {
            setActiveImages(images);
            setPhotoIndex(idx);
            setIsOpen(true);
          }}
          style={{
            width: isMobile ? "200px" : "400px",
            height: "auto",
            objectFit: "contain",
            cursor: "pointer",
            borderRadius: "8px",
            flexShrink: 0,
          }}
        />
      ))}
    </div>
  </div>
);

  const [photoIndex, setPhotoIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <div
        style={{
          padding: '40px',
          color: '#F3E5AB',
          fontFamily: 'Milonga, serif',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <h1 style={{ fontSize: '48px', marginBottom: '0px' }}>Gallery</h1>
      </div>

      <div
        style={{
          padding: isMobile ? '20px' : '100px',
          color: '#F3E5AB',
          fontFamily: 'Milonga, serif',
          fontSize: isMobile ? '18px' : '24px',
          textAlign: 'left',
          maxWidth: '1000px',
          margin: '0 auto',
        }}
      >
      <GalleryStrip title="Ork Models" images={orkImages} isMobile={isMobile} />

      <GalleryStrip title="Necron Models" images={necronImages} isMobile={isMobile} />
        
      {isOpen && (
      <Lightbox
          open={isOpen}
          close={() => setIsOpen(false)}
          index={photoIndex}
          slides={activeImages.map((src) => ({ src }))}
          on={{ view: ({ index }) => setPhotoIndex(index) }}
      />
      )}
      </div>
    </div>
  );
}
